export const BREAKDOWN_TEXT = {
	brokenDown: 'Broken down',
	timeOfIncident: 'Time of incident:',
	reason: 'Reason:',
	replacementType: 'Replacement type:',
	deadhead: 'Deadhead',
	parallelRide: 'Parallel ride',
	menuAriaLabel: 'Breakdown actions',
	viewBreakdownDetails: 'View breakdown details',
};
